export default __webpack_public_path__ + "static/microsoftoffice-5ad8bf677443d5eee96c02a850d4c453.png";